import { render, staticRenderFns } from "./StructureItem.vue?vue&type=template&id=bf286222&scoped=true&"
import script from "./StructureItem.vue?vue&type=script&lang=ts&"
export * from "./StructureItem.vue?vue&type=script&lang=ts&"
import style0 from "./StructureItem.vue?vue&type=style&index=0&id=bf286222&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bf286222",
  null
  
)

export default component.exports